<template>
<card>
    <b-card-header class="border-0">
        <h3 class="mb-0" style="font-size: 18px; font-weight: bold; color: #2c3e50;">
            SENARAI PENJAWAT AWAM DALAM TINDAKAN
        </h3>
    </b-card-header>

    <!-- <CarianBaharu
      @carianProgram="searchProgram"
      @resetPaging="resetPaging"
    ></CarianBaharu> -->

    <el-table v-loading="loading" class="table-responsive table" header-row-class-name="thead-light" :header-cell-style="{
    background: '#f6f9fc',
    color: '#000',
    fontWeight: 'bold',
    fontSize: '16px'
  }" :cell-style="{
    fontWeight: 600,
    color: '#000',
    fontSize: '14px'
  }" :data="SenaraiPenjawatAwam" style="width: 100%">
        <el-table-column align="center" type="index" :index="indexMethod" width="100px" />

        <el-table-column label="NAMA" prop="CONm" min-width="250px" :formatter="uppercase" />
        <el-table-column label="NO KAD PENGENALAN" prop="ICNo" min-width="250px" />
        <el-table-column label="JAWATAN" prop="jawatan" min-width="250px" />

        <el-table-column label="Tindakan" min-width="150px" align="right" fixed="right">
            <template v-slot="{ row }">
                <base-button size="xl" icon type="primary" class="mb-2" @click="showVal(row)">
                    <span class="btn-inner--icon"></span>
                    <span class="btn-inner--text">Lihat</span>
                </base-button>
                <base-button size="xl" icon type="danger" class="mb-2" @click="deleteRow(row)">
                    <span class="btn-inner--text">Hapus</span>
                </base-button>
            </template>
        </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
        <el-pagination background layout="prev, pager, next" :total="ClientPaging.totalRow" :page-size="ClientPaging.totalRowPerPaging" @current-change="pageChanged">
        </el-pagination>
    </b-card-footer>
</card>
</template>

<script>
import {
    Table,
    TableColumn,
    Pagination
} from "element-ui";
import GetsalaryService from "@/services/salaryService.js";
import Store from "@/store";
import Swal from 'sweetalert2'
import BaseButton from "@/components/BaseButton.vue";
// import CarianBaharu from "@/views/PindahPeruntukan/Penyedia/CarianBaharu.vue";

export default {
    name: "DASHBOARD",
    components: {
        BaseButton,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Pagination.name]: Pagination,

    },
    data() {
        return {
            SenaraiPenjawatAwam: [{
                    CONm: "shuk"
                },
                {
                    CONm: "bob"
                }
            ],
            currentPage: 1,
            ClientPaging: {
                pagingType: 2,
                totalRow: 0,
                totalRowPerPaging: 0,
                totalPage: 0,
                memTableName: null,
                lastPage: 0,
            },
            loading: false,
        };
    },

    methods: {
        uppercase(row, column, cellValue) {
    return cellValue ? cellValue.toUpperCase() : '';
  },
        pageChanged(val) {
            this.currentPage = val;
            this.queryPageData(val);
        },
        showVal(row) {
            console.log("nokp", row.ICNo)
            this.$router.push({
                name: 'BUTIRAN MAKLUMAT PERIBADI',
                params: {
                    ICNo: row.ICNo,
                }
            })
        },

        queryPageData(currentPage) {
            this.loading = false;

            let search = {
                currentPage: currentPage,
            };

            GetsalaryService.getSenaraiPenjawatAwamInfo(search)
                .then((resp) => {
                    this.ClientPaging = resp.data;
                    console.log("pagingInfo: ", resp.data);
                })
                .then(() => {
                    GetsalaryService.getSenaraiPenjawatAwamdata(
                        search
                    ).then((resp) => {
                        this.SenaraiPenjawatAwam = resp.data;
                        //console.log("pagingData: ", SenaraiPenjawatAwam);
                    });
                });
        },

        indexMethod(index) {
            return (
                index + 1 + (this.currentPage - 1) * this.ClientPaging.totalRowPerPaging
            );
        },

        deleteRow(row) {
        Swal.fire({
            title: 'Pengesahan',
            text: 'Adakah anda pasti mahu menghapus rekod ini?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ya, Hapus',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                // buat delete kat sini
                console.log('Delete row:', row)

                GetsalaryService.delRowPenjawatAwam(row)
                .then((resp) => {
                    // console.log(resp.data)
                    this.queryPageData(1);
                    this.$emit("refreshDashboard");
                    Swal.fire({
                        title: `HAPUS BERJAYA`,
                        text: "",
                        buttonsStyling: true,
                        icon: "success",
                    });
                    
                })
                .catch((err) => {
                    console.error(err);
                });
            }
        })
    },
    },

    created() {
        this.queryPageData(1);
    },
    // computed: {
    //   roleID() {
    //     return Store.state.Pengguna.roleID;
    //   },
    // },
};
</script>

<style scoped>
.table-responsive .el-table__header th {
    font-size: 16px;
    font-weight: bold;
    background-color: #f6f9fc;
    color: #000;
}

.table-responsive .el-table__body td {
    font-size: 14px;
    font-weight: 600;
    color: #000;
}

.b-card-header h3 {
    font-size: 20px;
    font-weight: bold;
    color: #2c3e50;
    /* biru gelap profesional */
}
</style>
